
/* injects from baggage-loader */

import React from 'react';
import { connect } from 'react-redux';
import { asyncWrapper } from '../../hocs/asyncWrapper';
import { lazyImport } from '@common/hocs/lazyImport';

const Admin = asyncWrapper(lazyImport(() => import('@admin')));

const AdminWrapper = (props) => {
    return <Admin
        {...props}
    />;
};

const mapStateToProps = (state) => {
    return {
        preferences: state.preferences
    };
};

export default connect(mapStateToProps)(AdminWrapper);